import { useLoginForm } from '../../../hooks/auth/useLoginForm';
import { useLoginCorporation } from '../../../hooks/auth/useLoginCorporation';
import { LoginForm } from '../../organisms/authentication/LoginForm';


export const LoginCorporation = () => {
  const { handleSubmit, register, isSubmitting, errors } = useLoginForm();
  const onSubmit = useLoginCorporation();
  return <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} isSubmitting={isSubmitting} title="法人ログイン" btnColor="green" />
};